import { inputAnatomy } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys);

const sm = defineStyle({
  h: '9',
  borderRadius: 'lg',
});

const md = defineStyle({
  h: '12',
  borderRadius: 'xl',
});

const lg = defineStyle({
  h: '14',
  borderRadius: '2xl',
});

const sizes = {
  sm: definePartsStyle({ field: sm, addon: sm }),
  md: definePartsStyle({ field: md, addon: md }),
  lg: definePartsStyle({ field: lg, addon: lg }),
};

const variantOutline = definePartsStyle(() => {
  return {
    field: {
      bg: 'white',
    },
  };
});

const variants = {
  outline: variantOutline,
};

export const inputTheme = defineMultiStyleConfig({
  sizes,
  variants,
});
